export function CategoryFilter({ categories, active, onChange }) {
  return (
    <div className="flex flex-wrap justify-center gap-2">
      {categories.map((cat) => (
        <button
          key={cat}
          type="button"
          onClick={() => onChange(cat)}
          className={`rounded-full border px-4 py-1.5 text-sm font-bold transition-colors ${
            active === cat
              ? 'border-accent bg-accent text-black'
              : 'border-white/10 text-text-muted hover:border-white/20 hover:text-text'
          }`}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}
